/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* ============= Page Top =============  */
document.addEventListener('click', function (event) {
  var button = event.target.closest('.c-button-page-top[data-action="page-top"]');
  if (!button) return;
  window.scrollTo({ top: 0, behavior: 'smooth' });
});


/* ============= Custom Variant Form =============  */
/* Mobile Modal Form */
(function() {
  const attachedButtons = new WeakSet();
  let closeHandler = null;
  let overlayHandler = null;
  let originalParent = null;
  let originalNextSibling = null;

  function initMobileVariantForm() {      
    const jsMobileVariantFormButtons = document.querySelectorAll('.jsMobileVariantFormButton');
    jsMobileVariantFormButtons.forEach(button => {
      if (attachedButtons.has(button)) return;        
      button.addEventListener('click', function() {
        const modal = document.querySelector(".c-modal-form--mobile-form");
        const mobileForm = document.querySelector(".c-product-form__mobile");
        if (modal) {          
          if (mobileForm && mobileForm.parentNode !== document.body) {            
            originalParent = mobileForm.parentNode;
            originalNextSibling = mobileForm.nextSibling;
            document.body.appendChild(mobileForm);
          }
          if (mobileForm) {
            mobileForm.classList.add("is-open");
          }
          modal.setAttribute("open", "true");
          document.documentElement.classList.add("lock-all");
        }
      });
      attachedButtons.add(button);
    });

    function popupClose_MobileVariantForm() {
      const modal = document.querySelector(".c-modal-form--mobile-form");
      const mobileForm = document.querySelector(".c-product-form__mobile");
      if (modal) {
        modal.setAttribute("open", "false");
        document.documentElement.classList.remove("lock-all");
        if (mobileForm) {
          mobileForm.classList.remove("is-open");
        }
        if (mobileForm && originalParent) {
          if (originalNextSibling) {
            originalParent.insertBefore(mobileForm, originalNextSibling);
          } else {
            originalParent.appendChild(mobileForm);
          }
          originalParent = null;
          originalNextSibling = null;
        }
      }
    }

    const closeIcon = document.querySelector(".c-modal-form--mobile-form .c-modal-form__close");
    if (closeIcon) {
      if (closeHandler) {
        closeIcon.removeEventListener("click", closeHandler);
      }
      closeHandler = popupClose_MobileVariantForm;
      closeIcon.addEventListener("click", closeHandler);
    }

    const closeButton = document.querySelector(".c-modal-form--mobile-form .c-modal-form__close-button");
    if (closeButton) {
      if (closeHandler) {
        closeButton.removeEventListener("click", closeHandler);
      }
      closeHandler = popupClose_MobileVariantForm;
      closeButton.addEventListener("click", closeHandler);
    }

    const overlay = document.querySelector(".c-modal-form--mobile-form .c-modal-form__overlay");
    if (overlay) {
      if (overlayHandler) {
        overlay.removeEventListener("click", overlayHandler);
      }
      overlayHandler = popupClose_MobileVariantForm;
      overlay.addEventListener("click", overlayHandler);
    }
  }
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMobileVariantForm);
  } else {
    initMobileVariantForm();
  }

  const mutationObserver = new MutationObserver((mutations) => {
    let shouldReinit = false;
    
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.classList?.contains("jsMobileVariantFormButton") ||
              node.classList?.contains("c-modal-form--mobile-form") ||
              node.querySelector?.(".jsMobileVariantFormButton") ||
              node.querySelector?.(".c-modal-form--mobile-form")) {
            shouldReinit = true;
          }
        }
      });
    });

    if (shouldReinit) {
      setTimeout(initMobileVariantForm, 100);
    }
  });

  mutationObserver.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* Product Media Gallery Switch */
(function() {
  if (window.customVariantOption1MediaBound) return;
  window.customVariantOption1MediaBound = true;

  function findProductMedia(trigger) {
    const productRoot = trigger.closest(".product");
    if (productRoot) {
      const media = productRoot.querySelector("product-media");
      if (media) return media;
    }

    const handle = trigger.closest(".c-variants-form")?.getAttribute("data-product-handle");
    if (!handle) return document.querySelector("product-media");

    const matches = Array.from(document.querySelectorAll("product-media")).filter((media) => media.getAttribute("product-handle") === handle);
    const opened = matches.find((media) => {
      const container = media.closest("quick-buy-drawer, quick-buy-popover");
      return container && container.hasAttribute("open");
    });
    return opened || matches[0] || null;
  }

  document.addEventListener("click", async function(event) {
    const trigger = event.target.closest(".c-variants-form__option1-image");
    if (!trigger) return;

    const mediaId = trigger.getAttribute("data-media-id");
    if (!mediaId) return;

    const productMedia = findProductMedia(trigger);
    const carousel = productMedia?.querySelector("flickity-carousel");
    const target = productMedia?.querySelector(`.product__media-item[data-media-id="${mediaId}"]`);
    if (!carousel || !target || typeof carousel.select !== "function") return;

    if (target.classList.contains("is-filtered")) {
      productMedia.querySelectorAll(`[data-media-id="${mediaId}"]`).forEach((item) => {
        item.classList.remove("is-filtered");
      });
      if (carousel.flickityInstance && typeof carousel.reload === "function") {
        await carousel.reload();
      }
    }

    if (!carousel.flickityInstance) return;
    await carousel.select(`.product__media-item[data-media-id="${mediaId}"]`);
  });
})();


/* ============= Custom Drawer =============  */
(function() {
  'use strict';
  if (customElements.get('custom-drawer')) {
    return;
  }
  function getDrawerToggles(drawerId) {
    if (!drawerId) {
      return [];
    }
    return Array.from(document.querySelectorAll(`[aria-controls="${CSS.escape(drawerId)}"]`));
  }

  function shouldLockDrawer(toggles) {
    return toggles.some((toggle) => !toggle.classList.contains('c-drawer-toggle--nolock'));
  }

  class CustomDrawer extends HTMLElement {
    constructor() {
      super();
      this._listenersAttached = false;
      this._triggerToggle = null;
      this._originalPosition = null;
    }

    _shouldTeleportToBody() {
      return this.hasAttribute('data-teleport-to-body');
    }

    _saveOriginalPosition() {
      if (!this._originalPosition) {
        this._originalPosition = {
          parent: this.parentElement,
          nextSibling: this.nextSibling
        };
      }
    }

    _teleportToBody() {
      if (!this._shouldTeleportToBody()) {
        return;
      }
      this._saveOriginalPosition();
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
    }

    _restoreFromBody() {
      if (!this._shouldTeleportToBody() || !this._originalPosition) {
        return;
      }
      const original = this._originalPosition;
      if (!original.parent) {
        return;
      }
      if (original.nextSibling && original.nextSibling.parentElement === original.parent) {
        original.parent.insertBefore(this, original.nextSibling);
      } else {
        original.parent.appendChild(this);
      }
    }
    connectedCallback() {
      if (this._listenersAttached) {
        return;
      }
      const overlay = this.querySelector('.drawer__overlay');
      const closeButton = this.querySelector('.drawer__close-button');     
      if (overlay) {
        overlay.addEventListener('click', () => {
          this.open = false;
        });
      }      
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.open = false;
        });
      }
      this._listenersAttached = true;
    }
    disconnectedCallback() {     
      this._listenersAttached = false;
    }
    static get observedAttributes() {
      return ['open'];
    }
    get open() {
      return this.hasAttribute('open');
    }
    set open(value) {
      if (value) {
        this.setAttribute('open', '');
      } else {
        this.removeAttribute('open');
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) {
        return;
      }

      if (name === 'open') {
        if (newValue !== null) {
          this._teleportToBody();
          const toggles = getDrawerToggles(this.id);
          if (toggles.length) {
            toggles.forEach((toggle) => {
              toggle.setAttribute('aria-expanded', 'true');
            });
            const lockToggles = this._triggerToggle ? [this._triggerToggle] : toggles;
            if (shouldLockDrawer(lockToggles) && !document.documentElement.classList.contains('lock-all')) {
              document.documentElement.classList.add('lock-all');
            }
          } else {
            const prevToggle = this.previousElementSibling;
            if (prevToggle && prevToggle.classList.contains('c-drawer-toggle')) {
              prevToggle.setAttribute('aria-expanded', 'true');
              if (shouldLockDrawer([prevToggle]) && !document.documentElement.classList.contains('lock-all')) {
                document.documentElement.classList.add('lock-all');
              }
            }
          }
          this.dispatchEvent(new CustomEvent('custom-drawer:open', {
            bubbles: true,
            detail: {
              drawer: this,
              trigger: this._triggerToggle
            }
          }));
        } else {
          const toggles = getDrawerToggles(this.id);
          if (toggles.length) {
            toggles.forEach((toggle) => {
              toggle.setAttribute('aria-expanded', 'false');
            });
          } else {
            const prevToggle = this.previousElementSibling;
            if (prevToggle && prevToggle.classList.contains('c-drawer-toggle')) {
              prevToggle.setAttribute('aria-expanded', 'false');
            }
          }
          this._triggerToggle = null;
          this._restoreFromBody();

          const otherOpenDrawers = document.querySelectorAll('custom-drawer[open]');
          let hasLockDrawer = false;
          otherOpenDrawers.forEach((drawer) => {
            if (drawer.id && shouldLockDrawer(getDrawerToggles(drawer.id))) {
              hasLockDrawer = true;
            }
          });

          if (!hasLockDrawer) {
            const themeDrawers = document.querySelectorAll('drawer-content[open]');
            if (themeDrawers.length === 0) {
              document.documentElement.classList.remove('lock-all');
            }
          }
          this.dispatchEvent(new CustomEvent('custom-drawer:close', {
            bubbles: true,
            detail: {
              drawer: this
            }
          }));
        }
      }
    }
  }

  customElements.define('custom-drawer', CustomDrawer);

  document.addEventListener('click', function (event) {
    let toggle = event.target.closest('.c-drawer-toggle');
    if (!toggle) {
      const candidate = event.target.closest('[aria-controls]');
      if (candidate) {
        const candidateDrawerId = candidate.getAttribute('aria-controls');
        const candidateDrawer = candidateDrawerId && document.getElementById(candidateDrawerId);
        if (candidateDrawer && candidateDrawer.tagName.toLowerCase() === 'custom-drawer') {
          toggle = candidate;
        }
      }
    }
    if (!toggle) {
      return;
    }

    if (toggle.getAttribute('is') === 'toggle-button' && !toggle.classList.contains('c-drawer-toggle')) {
      return;
    }

    let drawer = null;
    const drawerId = toggle.getAttribute('aria-controls');
    if (drawerId) {
      const target = document.getElementById(drawerId);
      if (target && target.tagName.toLowerCase() === 'custom-drawer') {
        drawer = target;
      }
    }
    if (!drawer && toggle.classList.contains('c-drawer-toggle')) {
      const sibling = toggle.nextElementSibling;
      if (sibling && sibling.tagName.toLowerCase() === 'custom-drawer') {
        drawer = sibling;
      }
    }
    if (!drawer) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    drawer._triggerToggle = toggle;
    drawer.open = !drawer.open;
  }, { passive: false });
})();

/* ============= Custom Modal ============= */
(function() {
  'use strict';

  function getModalToggles(modalId) {
    if (!modalId) {
      return [];
    }
    return Array.from(document.querySelectorAll(`[aria-controls="${CSS.escape(modalId)}"]`));
  }

  function syncModalToggleExpanded(modal, expanded) {
    if (!modal.id) {
      return;
    }
    getModalToggles(modal.id).forEach((toggle) => {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  document.addEventListener('openable-element:open', function(event) {
    if (event.target.tagName.toLowerCase() !== 'modal-content' || !event.target.classList.contains('c-modal')) {
      return;
    }
    syncModalToggleExpanded(event.target, true);
  });

  document.addEventListener('openable-element:close', function(event) {
    if (event.target.tagName.toLowerCase() !== 'modal-content' || !event.target.classList.contains('c-modal')) {
      return;
    }
    syncModalToggleExpanded(event.target, false);
  });

  document.addEventListener('click', function(event) {
    let toggle = event.target.closest('.c-modal-toggle');
    if (!toggle) {
      const candidate = event.target.closest('[aria-controls]');
      if (candidate) {
        const candidateModalId = candidate.getAttribute('aria-controls');
        const candidateModal = candidateModalId && document.getElementById(candidateModalId);
        if (candidateModal && candidateModal.tagName.toLowerCase() === 'modal-content' && candidateModal.classList.contains('c-modal')) {
          toggle = candidate;
        }
      }
    }
    if (!toggle) {
      return;
    }

    if (toggle.getAttribute('is') === 'toggle-button' && !toggle.classList.contains('c-modal-toggle')) {
      return;
    }

    let modal = null;
    const modalId = toggle.getAttribute('aria-controls');
    if (modalId) {
      const target = document.getElementById(modalId);
      if (target && target.tagName.toLowerCase() === 'modal-content' && target.classList.contains('c-modal')) {
        modal = target;
      }
    }
    if (!modal && toggle.classList.contains('c-modal-toggle')) {
      const sibling = toggle.nextElementSibling;
      if (sibling && sibling.tagName.toLowerCase() === 'modal-content' && sibling.classList.contains('c-modal')) {
        modal = sibling;
      }
    }
    if (!modal) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    modal.open = !modal.open;
  }, { passive: false });
})();
